import {
    SMB_LOGIN_REQUEST,
    SMB_LOGIN_RESPONSE,
    SET_SMB_DELIVERY_STYLE,
    SET_SMB_DETAILS_ENTRY_TYPE,
    SET_SMB_GRID_DATA,
    SET_SMB_SELECTED_PRODUCT,
    UPDATE_SMB_GRID_DATA_ROW,
    SMB_REGISTRATION_REQUEST,
    SMB_REGISTRATION_RESPONSE,
    CREATE_SMB_ORDER_RESPONSE,
    SMB_ORDER_CANCELLED,
    SMB_GET_CART_CONTENTS_RESPONSE,
    SMB_ADD_TO_CART,
    SET_SMB_SELECTED_GIFT_TEMPLATE,
    SMB_SET_CART_FLYOUT_MODE,
    SMB_MARK_CART_ITEM_FOR_DELETION,
    SMB_ITEMS_SYNCED_TO_BACKEND,
    SMB_CHECK_LOGIN_RESPONSE,
    SMB_RESET_CART,
    SMB_SET_ORDER_STATUS,
    SMB_SET_EDIT_ITEM,
    SMB_EDIT_CART_ITEM_REQUEST,
    SMB_EDIT_CART_ITEM_RESPONSE,
    SMB_CLEAR_EDIT_SUCCESS,
    SMB_CANCEL_EDIT_ITEM,
    SMB_UPDATE_COBRAND_CARD,
    SMB_RESET_COBRAND_BUILDER,
    SMB_UPDATE_COBRAND_CARD_LOGO,
    SMB_UPDATE_COBRAND_CARD_LOGO_ZOOM,
    SMB_CHECK_LOGIN_REQUEST,
    GET_SMB_STATUS_RESPONSE,
    SMB_GET_CART_CONTENTS_REQUEST,
    CLEAR_SMB_REGISTRATION_ERROR,
    SET_CUSTOMIZE_STEP,
    SMB_LOGOUT,
    SET_SMB_CHECKOUT_STEP,
    SMB_INITIALIZE_COBRAND_CARD_LOGO_VALUES,
    SMB_UPDATE_COBRAND_CARD_LOGO_PLACEMENT_ERROR,
    SET_SMB_GUEST_USER_INFO,
    SET_SMB_ANTICIPATED_LOAD_VALUE,
    SET_SMB_ANTICIPATED_QUANTITY,
    SET_SMB_ALREADY_CHOSE_QTY_AND_LOAD_VALUE,
    SET_SMB_APPLY_ALL_OVERRIDES,
    SET_SMB_CARDS,
    SET_SMB_RELOAD_CARDS,
    SET_SMB_ANTICIPATED_NAME_ON_CARD,
    SET_SMB_ANTICIPATED_MESSAGE_ON_CARD,
    SET_SELECTED_CARD_STYLE,
    SET_SELECTED_DESIGN_TYPE,
    SET_SELECTED_CARD_NETWORK,
    SET_SELECTED_CARD_TYPE,
    CLEAR_SAVED_DESIGN,
    SET_SELECTED_SKU,
    SET_AVAILABLE_SKUS,
    SET_SMB_PAYMENT_ERROR,
    CLEAR_SMB_PAYMENT_ERROR,
    SET_SMB_MOST_RECENT_COBRAND,
    SET_SMB_CARRIER_TYPE,
    SET_SMB_SELECTED_GREETING_CARD,
    SET_SMB_PERSONALIZATION_FLOW,
} from '../actions/smbCart'
import {
    ORDER_STATUS,
    CART_SOURCE,
    DELIVERY_STYLE,
    SMB_CUSTOMIZE_STEP,
    SMB_CHECKOUT_STEP,
    CARD_TYPE,
    PERSONALIZATION_FLOW,
} from '../components/SmallBusiness/SmbConstants'
import {
    DIGITAL_ATTRIBUTES,
    PHYSICAL_ATTRIBUTES,
} from '../components/SmallBusiness/OrderFlow/CustomizationGridAttributes'
import CobrandCard from '../components/Models/CobrandCard'
import { v4 as uuidv4 } from 'uuid'
import has from 'lodash/has'
import isNil from 'lodash/isNil'
import { SMB_DEFAULT_SYNC_ERROR_MESSAGE } from '../errorConstants'
import isSmbProgram from '../components/SmallBusiness/utils/isSmbProgram'

export const initialState = {
    selectedProduct: null,
    gridData: [],
    user: null,
    guestUserInfo: {
        contactEmail: '',
        contactName: '',
    },
    isLoggedIn: false,
    loginIsLoading: false,
    loginError: null,
    checkLoginIsLoading: true,
    smbStatus: {
        user_id: null,
        user_email: null,
        smb_status: null,
        _token: null,
    },
    smbStatusError: null,
    smbStatusIsLoading: true,
    registrationIsLoading: false,
    registrationError: null,
    paymentMethods: [],
    orderStatus: ORDER_STATUS.INCOMPLETE,
    cancelReason: null,
    orderResponse: {
        order: null,
        cards: [],
    },
    itemsPayload: {
        source: CART_SOURCE,
        delivery_groups: [],
        cards: [],
    },
    cartContents: null,
    cartContentsAreLoading: true,
    cartFlyoutMode: {
        display: false,
        addingToCart: false,
        addedToCart: false,
    },
    cartItemMarkedForDeletion: {
        openModal: false,
        cartId: null,
        item: null,
    },
    syncError: null,
    editingCartItemDeliveryGroupId: null,
    editingFromPlaceOrder: false,
    cartItemsCustomizationData: [],
    editCartItemLoading: false,
    editCartItemError: null,
    editCartItemSuccess: false,
    cobrandCard: new CobrandCard(),
    mostRecentCobrand: null,
    customizeStep: SMB_CUSTOMIZE_STEP.INFORMATION_ADDING_TYPE_SELECTION,
    checkoutStep: SMB_CHECKOUT_STEP.SHIPPING,
    personalizationFlow: PERSONALIZATION_FLOW.EXPRESS,
    applyAllOverrides: {},
    smbCards: [],
    smbReloadCards: false,
    selectedCardStyle: null,
    selectedDesignType: null,
    selectedCardNetwork: 'visa',
    selectedCardType: CARD_TYPE.PLASTIC,
    availableSkus: [],
    selectedSku: null,
    anticipatedLoadValue: 0,
    anticipatedQuantity: 0,
    alreadyChoseQtyAndLoadValue: false,
    anticipatedNameOnCard: '',
    anticipatedMessageOnCard: '',
    paymentError: null,
    carrierType: 'trifold',
    selectedGreetingCard: null,
}

const resetRequestedFlag = (action) =>
    has(action, 'meta') &&
    !isNil(action.meta) &&
    !isNil(action.meta.resetRequested)
        ? { resetRequested: true }
        : {}

export default function smbCartReducer(state = initialState, action) {
    switch (action.type) {
        case SET_SMB_CARDS:
            return {
                ...state,
                smbCards: [...action.payload],
            }
        case SET_SMB_RELOAD_CARDS:
            return {
                ...state,
                smbReloadCards: action.payload,
            }
        case SET_SMB_APPLY_ALL_OVERRIDES:
            return {
                ...state,
                applyAllOverrides: {
                    ...state.applyAllOverrides,
                    ...action.payload,
                },
            }
        case SET_SMB_SELECTED_GIFT_TEMPLATE:
            return {
                ...state,
                selectedProduct: {
                    ...state.selectedProduct,
                    selectedGiftTemplate: action.payload,
                },
            }
        case SMB_LOGIN_REQUEST:
            return { ...state, loginIsLoading: true }
        case SMB_LOGIN_RESPONSE:
            if (action.error) {
                return {
                    ...state,
                    loginError: action.payload,
                    loginIsLoading: false,
                }
            }
            return {
                ...state,
                loginError: null,
                loginIsLoading: false,
            }
        case SMB_REGISTRATION_REQUEST:
            return {
                ...state,
                registrationIsLoading: true,
                registrationError: null,
            }
        case SMB_REGISTRATION_RESPONSE:
            if (action.error) {
                return {
                    ...state,
                    registrationError: action.payload,
                    registrationIsLoading: false,
                }
            }
            return {
                ...state,
                registrationError: null,
                registrationIsLoading: false,
            }
        case CLEAR_SMB_REGISTRATION_ERROR:
            return {
                ...state,
                registrationError: null,
            }
        case SET_SMB_SELECTED_PRODUCT:
            if (action.payload === null) {
                return {
                    ...state,
                    selectedProduct: null,
                }
            }

            return {
                ...state,
                selectedProduct: {
                    ...(state.selectedProduct || {}),
                    product: action.payload.product,
                    selectedGiftTemplate:
                        state.selectedProduct?.selectedGiftTemplate || null,
                    deliveryStyle:
                        action.payload.deliveryStyle ||
                        has(state.selectedProduct, 'deliveryStyle')
                            ? state.selectedProduct.deliveryStyle
                            : null,
                    detailsEntryType:
                        action.payload.detailsEntryType ||
                        has(state.selectedProduct, 'detailsEntryType')
                            ? state.selectedProduct.detailsEntryType
                            : null,
                    savedDesign: action.payload?.savedDesign ?? null,
                    isVirtualProduct:
                        state.selectedProduct?.product?.isVirtualProduct,
                },
            }
        case SET_SMB_DELIVERY_STYLE:
            return {
                ...state,
                selectedProduct: {
                    ...state.selectedProduct,
                    deliveryStyle: action.payload,
                },
            }
        case SET_SMB_PERSONALIZATION_FLOW:
            return {
                ...state,
                personalizationFlow: action.payload,
            }
        case SET_SMB_DETAILS_ENTRY_TYPE:
            return {
                ...state,
                selectedProduct: {
                    ...state.selectedProduct,
                    detailsEntryType: action.payload,
                },
            }
        case SET_SMB_ANTICIPATED_LOAD_VALUE:
            return {
                ...state,
                anticipatedLoadValue: action.payload,
            }
        case SET_SMB_ANTICIPATED_QUANTITY:
            return {
                ...state,
                anticipatedQuantity: action.payload,
            }
        case SET_SMB_ANTICIPATED_NAME_ON_CARD:
            return {
                ...state,
                anticipatedNameOnCard: action.payload,
            }
        case SET_SMB_ANTICIPATED_MESSAGE_ON_CARD:
            return {
                ...state,
                anticipatedMessageOnCard: action.payload,
            }
        case SET_SMB_ALREADY_CHOSE_QTY_AND_LOAD_VALUE:
            return {
                ...state,
                alreadyChoseQtyAndLoadValue: action.payload,
            }
        case SET_SMB_GRID_DATA:
            return {
                ...state,
                gridData: action.payload,
            }
        case UPDATE_SMB_GRID_DATA_ROW:
            if (action.payload && action.payload.removeAddressFields) {
                return {
                    ...state,
                    gridData: state.gridData.map((row) => {
                        let rowData = row
                        if (row.hasOwnProperty('address')) {
                            const { address, ...restOfRowData } = row
                            rowData = restOfRowData
                        }
                        if (row.hasOwnProperty('emailAddress')) {
                            const { emailAddress, ...restOfRowData } = row
                            rowData = restOfRowData
                        }
                        return rowData
                    }),
                }
            }
            return {
                ...state,
            }
        case CREATE_SMB_ORDER_RESPONSE:
            if (action.error) {
                return {
                    ...state,
                    orderError: action.payload.errors,
                }
            }
            return {
                ...state,
                orderStatus: ORDER_STATUS.COMPLETE,
                orderResponse: {
                    order: action.payload.order,
                    cards: action.payload.cards,
                },
            }
        case SMB_ORDER_CANCELLED:
            return {
                ...state,
                orderStatus: ORDER_STATUS.CANCELLED,
                cancelReason: action.payload.cancelReason,
                orderResponse: {
                    order: action.payload.order,
                    cards: action.payload.cards,
                },
            }
        case SMB_SET_ORDER_STATUS:
            return {
                ...state,
                orderStatus: action.payload,
            }
        case SMB_GET_CART_CONTENTS_REQUEST:
            return {
                ...state,
                cartContentsAreLoading: true,
            }
        case SMB_GET_CART_CONTENTS_RESPONSE:
            if (action.meta?.status === 204) {
                return {
                    ...state,
                    cartContents: null,
                    cartItemsCustomizationData: [],
                    cartContentsAreLoading: false,
                }
            }
            if (action.error || !has(action.payload, 'cart')) {
                return {
                    ...state,
                    cartContentsAreLoading: false,
                }
            }

            return {
                ...state,
                cartContents: { ...action.payload.cart },
                cartItemsCustomizationData:
                    getCustomizationDataFromCartContents(action.payload.cart),
                cartContentsAreLoading: false,
            }
        case SMB_ADD_TO_CART:
            return {
                ...state,
                itemsPayload: {
                    ...state.itemsPayload,
                    delivery_groups: [
                        ...(state.itemsPayload.delivery_groups || []),
                        action.payload.newDeliveryGroup,
                    ],
                    cards: [
                        ...(state.itemsPayload.cards || []),
                        ...action.payload.newCards,
                    ],
                },
                ...resetRequestedFlag(action),
            }
        case SMB_RESET_CART:
            return {
                ...state,
                cartContents: null,
                cartFlyoutMode: {
                    ...state.cartFlyoutMode,
                    addedToCart: false,
                },
            }
        case SMB_MARK_CART_ITEM_FOR_DELETION:
            return {
                ...state,
                cartItemMarkedForDeletion: {
                    openModal: action.payload.openModal,
                    cartId: action.payload.cartId,
                    item: action.payload.item,
                },
            }
        case SMB_SET_CART_FLYOUT_MODE:
            return {
                ...state,
                cartFlyoutMode: {
                    ...state.cartFlyoutMode,
                    ...action.payload,
                },
            }
        case SMB_ITEMS_SYNCED_TO_BACKEND:
            let removingFromCart = false
            if (has(action.meta, 'removingFromCart')) {
                removingFromCart = action.meta.removingFromCart
            }
            return action.error || !has(action.payload, 'cart')
                ? {
                      ...state,
                      itemsPayload: {
                          source: CART_SOURCE,
                          delivery_groups: [],
                          cards: [],
                      },
                      syncError: {
                          code: action.payload.error_code,
                          message:
                              action.payload.message ||
                              SMB_DEFAULT_SYNC_ERROR_MESSAGE,
                          errors: action.payload?.errors,
                          errorUpdatingDeliveryGroupShippingInfo:
                              action?.meta
                                  ?.errorUpdatingDeliveryGroupShippingInfo,
                      },
                  }
                : !removingFromCart
                ? {
                      ...state,
                      cartContents: { ...action.payload.cart },
                      cartItemsCustomizationData:
                          getCustomizationDataFromCartContents(
                              action.payload.cart
                          ),
                      itemsPayload: {
                          ...state.itemsPayload,
                          delivery_groups: [],
                          cards: [],
                      },
                      gridData: [], // only reset if add to cart sync was successful
                      syncError: null,
                  }
                : {
                      ...state,
                      cartContents: { ...action.payload.cart },
                      syncError: null,
                  }
        case GET_SMB_STATUS_RESPONSE:
            if (action.error) {
                return {
                    ...state,
                    smbStatusError: action.payload,
                    smbStatus: {},
                    smbStatusIsLoading: false,
                    smbSubmitSuccess: false,
                }
            }
            return {
                ...state,
                smbStatus: action.payload.data,
                smbStatusError: null,
                smbStatusIsLoading: false,
            }
        case SMB_CHECK_LOGIN_REQUEST:
            return {
                ...state,
                checkLoginIsLoading: true,
            }
        case SMB_CHECK_LOGIN_RESPONSE:
            return {
                ...state,
                isLoggedIn: action.payload.isLoggedIn,
                user: action.payload.user,
                checkLoginIsLoading: false,
            }
        case SET_SMB_GUEST_USER_INFO:
            return {
                ...state,
                guestUserInfo: action.payload,
            }
        case SMB_SET_EDIT_ITEM: {
            /************************************************************
             * GOAL (Plain English):
             * We are switching into "edit mode" for one cart item.
             * To do that we:
             * 1. Figure out which delivery group we are editing.
             * 2. Find the saved customization data for that group.
             * 3. Build a list of "card objects" (smbCards) from its grid rows,
             *    so the edit screen shows the correct info (not old/stale data).
             ************************************************************/

            // 1. Which delivery group are we editing?
            const deliveryGroupId =
                action.payload.editingCartItemDeliveryGroupId

            // 2. Find the stored customization info for that group.
            const targetCustomization = state.cartItemsCustomizationData.find(
                (item) => item.deliveryGroup.uuid === deliveryGroupId
            )

            // If we found it, grab some helpful flags we will use below.
            const isIndividualDeliveryStyle =
                targetCustomization?.deliveryGroup?.delivery_style ===
                    DELIVERY_STYLE.INDIVIDUAL ||
                targetCustomization?.deliveryGroup?.delivery_style ===
                    DELIVERY_STYLE.INDIVIDUAL_EMAIL

            const isVirtualProduct =
                !!targetCustomization?.product?.virtual_card

            /************************************************************
             * Helper: makes a single field object.
             * Each field keeps:
             * - value: what the user sees
             * - overrideValue: (unused here, keep empty)
             * - touched: pretend the user already interacted so validation acts normally
             * - valid: simple "is it filled?" check (real validation happens later)
             ************************************************************/
            function makeField(value = '') {
                return {
                    value: value ?? '',
                    overrideValue: '',
                    touched: true,
                    valid: value === 0 || !!value, // allow zero; treat empty string as invalid for now
                }
            }

            /************************************************************
             * Helper: build one virtual (digital) card from a row of grid data.
             ************************************************************/
            function buildVirtualCard(row) {
                return {
                    touched: true,
                    valid: true,
                    error: false,
                    cardAmount: makeField(row[DIGITAL_ATTRIBUTES.AMOUNT.name]),
                    cardRecipientFullName: makeField(
                        row[DIGITAL_ATTRIBUTES.FULL_NAME.name]
                    ),
                    emailAddress: makeField(
                        isIndividualDeliveryStyle
                            ? row[DIGITAL_ATTRIBUTES.EMAIL_ADDRESS.name]
                            : ''
                    ),
                    carrierMessage: makeField(
                        row[DIGITAL_ATTRIBUTES.EMAIL_MESSAGE.name]
                    ),
                    cardSenderFullName: makeField(
                        row[DIGITAL_ATTRIBUTES.SENDER_NAME.name]
                    ),

                    // Physical-only fields kept empty
                    nameOnCard: makeField(''),
                    cardMessage: makeField(''),
                    cardRecipientAddressRecipientName: makeField(''),
                    cardRecipientAddressAddressLine1: makeField(''),
                    cardRecipientAddressAddressLine2: makeField(''),
                    cardRecipientAddressCity: makeField(''),
                    cardRecipientAddressState: makeField(''),
                    cardRecipientAddressZip: makeField(''),
                }
            }

            /************************************************************
             * Helper: build one physical card from a row of grid data.
             * We have to carefully choose who the card is "sent to".
             * Explanation (simplified):
             * - If individual delivery style: prefer shipTo.name if it exists.
             * - Otherwise use the "Carrier To" value from the row.
             ************************************************************/
            function buildPhysicalCard(row) {
                const shipTo = row[PHYSICAL_ATTRIBUTES.SHIP_TO.name]

                // Decide the display name for the recipient.
                let recipientName
                if (isIndividualDeliveryStyle) {
                    // Prefer shipTo.name if non-empty, else fall back to "Carrier To".
                    const hasShipToName =
                        shipTo?.name && shipTo.name.trim() !== ''
                    recipientName = hasShipToName
                        ? shipTo.name
                        : row[PHYSICAL_ATTRIBUTES.CARRIER_TO.name]
                } else {
                    // Not individual style => always use "Carrier To".
                    recipientName = row[PHYSICAL_ATTRIBUTES.CARRIER_TO.name]
                }

                // Address fields only matter in individual delivery style.
                const addressIfNeeded = (val) =>
                    isIndividualDeliveryStyle ? val || '' : ''

                return {
                    touched: true,
                    valid: true,
                    error: false,
                    cardAmount: makeField(row[PHYSICAL_ATTRIBUTES.AMOUNT.name]),
                    nameOnCard: makeField(
                        row[PHYSICAL_ATTRIBUTES.NAME_ON_CARD.name]
                    ),
                    cardMessage: makeField(
                        row[PHYSICAL_ATTRIBUTES.CARD_MESSAGE.name]
                    ),
                    cardRecipientFullName: makeField(recipientName),
                    cardSenderFullName: makeField(
                        row[PHYSICAL_ATTRIBUTES.CARRIER_FROM.name]
                    ),
                    carrierMessage: makeField(
                        row[PHYSICAL_ATTRIBUTES.CARRIER_MESSAGE.name]
                    ),

                    // Virtual-only fields (not used here)
                    emailAddress: makeField(''),

                    // Mailing address (only if individual style)
                    cardRecipientAddressRecipientName: makeField(
                        addressIfNeeded(shipTo?.name)
                    ),
                    cardRecipientAddressAddressLine1: makeField(
                        addressIfNeeded(shipTo?.addressLine1)
                    ),
                    cardRecipientAddressAddressLine2: makeField(
                        addressIfNeeded(shipTo?.addressLine2)
                    ),
                    cardRecipientAddressCity: makeField(
                        addressIfNeeded(shipTo?.city)
                    ),
                    cardRecipientAddressState: makeField(
                        addressIfNeeded(shipTo?.state)
                    ),
                    cardRecipientAddressZip: makeField(
                        addressIfNeeded(shipTo?.zip)
                    ),
                }
            }

            /************************************************************
             * 3. Build smbCards from the grid rows.
             * If we don't have customization data, we just keep an empty list for now.
             ************************************************************/
            let newSmbCards = []
            if (targetCustomization) {
                const rows = targetCustomization.gridData
                newSmbCards = rows.map((row) =>
                    isVirtualProduct
                        ? buildVirtualCard(row)
                        : buildPhysicalCard(row)
                )
            }

            /************************************************************
             * 4. Return the updated state object.
             * We only replace smbCards if we successfully built them.
             ************************************************************/
            return {
                ...state,
                editingCartItemDeliveryGroupId: deliveryGroupId,
                editingFromPlaceOrder: action.payload.editingFromPlaceOrder,
                editCartItemError: null,
                selectedProduct: getCustomizationProductData(
                    state.cartItemsCustomizationData,
                    deliveryGroupId
                ),
                gridData: getCustomizationGridData(
                    state.cartItemsCustomizationData,
                    deliveryGroupId
                ),
                smbCards: newSmbCards.length ? newSmbCards : state.smbCards,
                // Ensure carrierType reflects the item being edited, not the last UI selection
                carrierType:
                    targetCustomization?.carrierType === 'greeting_card'
                        ? 'greeting_card'
                        : 'trifold',
            }
        }
        case SMB_CANCEL_EDIT_ITEM:
            return {
                ...state,
                editingCartItemDeliveryGroupId: null,
                gridData: [],
                editCartItemError: null,
                editCartItemLoading: false,
                editCartItemSuccess: false,
            }
        case SMB_EDIT_CART_ITEM_REQUEST:
            return {
                ...state,
                itemsPayload: {
                    ...state.itemsPayload,
                    delivery_groups: [
                        ...(state.itemsPayload.delivery_groups || []),
                        action.payload.newDeliveryGroup,
                    ],
                    cards: [
                        ...(state.itemsPayload.cards || []),
                        ...action.payload.newCards,
                    ],
                },
                editCartItemLoading: true,
                editCartItemError: null,
                editCartItemSuccess: false,
            }
        case SMB_EDIT_CART_ITEM_RESPONSE:
            if (action.error) {
                return {
                    ...state,
                    editCartItemError: action.payload,
                    editCartItemLoading: false,
                    editCartItemSuccess: false,
                }
            }
            return {
                ...state,
                editCartItemError: null,
                editCartItemLoading: false,
                editCartItemSuccess: true,
                editingCartItemDeliveryGroupId: null,
            }
        case SMB_CLEAR_EDIT_SUCCESS:
            return { ...state, editCartItemSuccess: false }
        case SMB_UPDATE_COBRAND_CARD:
            return {
                ...state,
                cobrandCard: action.payload,
            }
        case SMB_UPDATE_COBRAND_CARD_LOGO:
            return {
                ...state,
                cobrandCard: {
                    ...state.cobrandCard,
                    logo: action.payload,
                },
            }
        case SMB_UPDATE_COBRAND_CARD_LOGO_ZOOM:
            return {
                ...state,
                cobrandCard: {
                    ...state.cobrandCard,
                    logoZoom: action.payload,
                },
            }
        case SMB_RESET_COBRAND_BUILDER:
            return {
                ...state,
                cobrandCard: new CobrandCard(),
            }
        case SMB_INITIALIZE_COBRAND_CARD_LOGO_VALUES:
            // Initial logo zoom should be max
            const { maxLogoZoom, minLogoX, minLogoY } = action.payload
            return {
                ...state,
                cobrandCard: {
                    ...state.cobrandCard,
                    maxLogoZoom,
                    logoZoom: maxLogoZoom,
                    logoX: minLogoX,
                    logoY: minLogoY,
                },
            }
        case SMB_UPDATE_COBRAND_CARD_LOGO_PLACEMENT_ERROR:
            return {
                ...state,
                cobrandCard: {
                    ...state.cobrandCard,
                    logoPlacementError: action.payload,
                },
            }
        case SET_SMB_MOST_RECENT_COBRAND:
            return {
                ...state,
                mostRecentCobrand: action.payload
                    ? {
                          ...action.payload,
                          cobrand_uuid: action.payload.uuid,
                          uuid: undefined,
                          card_type: CARD_TYPE.PLASTIC,
                      }
                    : null,
            }
        case SET_CUSTOMIZE_STEP:
            return {
                ...state,
                customizeStep: action.payload,
            }
        case SMB_LOGOUT:
            return {
                ...state,
                isLoggedIn: false,
            }
        case SET_SMB_CHECKOUT_STEP: {
            return {
                ...state,
                checkoutStep: action.payload,
            }
        }
        case SET_SELECTED_CARD_STYLE: {
            return {
                ...state,
                selectedCardStyle: action.payload,
            }
        }
        case SET_SELECTED_DESIGN_TYPE: {
            return {
                ...state,
                selectedDesignType: action.payload,
            }
        }
        case SET_SELECTED_CARD_NETWORK: {
            return {
                ...state,
                selectedCardNetwork: action.payload.toLowerCase(),
            }
        }
        case SET_SELECTED_CARD_TYPE: {
            return {
                ...state,
                selectedCardType: action.payload.toLowerCase(),
            }
        }
        case SET_SMB_CARRIER_TYPE:
            return {
                ...state,
                carrierType:
                    action.payload === 'greeting_card'
                        ? 'greeting_card'
                        : 'trifold',
            }
        case SET_SMB_SELECTED_GREETING_CARD:
            return {
                ...state,
                selectedGreetingCard: action.payload,
            }
        case SET_AVAILABLE_SKUS: {
            return {
                ...state,
                availableSkus: action.payload,
            }
        }
        case SET_SELECTED_SKU: {
            return {
                ...state,
                selectedSku: action.payload,
            }
        }
        case CLEAR_SAVED_DESIGN: {
            return {
                ...state,
                selectedProduct: {
                    ...state.selectedProduct,
                    savedDesign: null,
                },
            }
        }
        case SET_SMB_PAYMENT_ERROR:
            return {
                ...state,
                paymentError: action.payload,
            }

        case CLEAR_SMB_PAYMENT_ERROR:
            return {
                ...state,
                paymentError: null,
            }
        default:
            return state
    }
}

// Gets gridData for for cart items for the given deliveryGroupId
function getCustomizationGridData(dataItems, deliveryGroupId) {
    return (
        dataItems.filter(
            (item) => item.deliveryGroup.uuid === deliveryGroupId
        )[0]?.gridData || []
    )
}

// Gets selectedProduct data for cart items for the given deliveryGroupId
function getCustomizationProductData(dataItems, deliveryGroupId) {
    const dataItem = dataItems.filter(
        (item) => item.deliveryGroup.uuid === deliveryGroupId
    )[0]

    return {
        product: dataItem?.product || null,
        deliveryStyle: dataItem?.deliveryGroup.delivery_style || null,
        detailsEntryType: dataItem?.detailsEntryType || null,
        selectedGiftTemplate: dataItem?.selectedGiftTemplate || null,
        is_smb_program: isSmbProgram(dataItem),
    }
}

// Use the cart response object to build a data structure that can be used
// to edit cart items.
function getCustomizationDataFromCartContents(cart) {
    const customizationData = cart.delivery_groups.map((deliveryGroup) => {
        const deliveryGroupCards = cart.cart_items.filter((item) => {
            return item.delivery_group_uuid === deliveryGroup.uuid
        })
        const individualDeliveryStyle =
            deliveryGroup.delivery_style === DELIVERY_STYLE.INDIVIDUAL ||
            deliveryGroup.delivery_style === DELIVERY_STYLE.INDIVIDUAL_EMAIL
        // Use the first card to extract product data for legacy structure
        const firstCard = deliveryGroupCards[0]
        // For legacy cards, destructure the custom_card_details' wcp_product property if available.
        const wcpOpenLoopProduct =
            firstCard.custom_card_details &&
            firstCard.custom_card_details.wcp_product
        const { card_image_url, ...restOfWcpProduct } = wcpOpenLoopProduct || {
            card_image_url: null,
        }

        // Derive carrier type for this delivery group: if any card has greeting_card info or fee, treat as greeting card
        const hasGreetingCard = deliveryGroupCards.some((card) => {
            const hasGreetingCardObject =
                card.greeting_card !== null && card.greeting_card !== undefined
            const hasGreetingCardFee =
                typeof card.greeting_card_fee === 'number' &&
                card.greeting_card_fee > 0

            return hasGreetingCardObject || hasGreetingCardFee
        })

        const carrierType = hasGreetingCard ? 'greeting_card' : 'trifold'

        return {
            deliveryGroup: deliveryGroup,
            detailsEntryType: 'manual',
            product: {
                cobrand_uuid: firstCard.cobrand_uuid ?? undefined,
                card_image_url: wcpOpenLoopProduct
                    ? firstCard.custom_card_details.custom_card_image
                    : firstCard.custom_card_image,
                ...restOfWcpProduct,
            },
            selectedGiftTemplate: firstCard.on_demand_gift_template,
            carrierType,
            gridData: deliveryGroupCards.map((card) => {
                // Check if the card uses legacy shape (custom_card_details exists)
                const isLegacy = !!card.custom_card_details
                if (card.plastic) {
                    const gridRowData = {
                        rowId: uuidv4(),
                        [PHYSICAL_ATTRIBUTES.AMOUNT.name]: isLegacy
                            ? card.custom_card_details.load_value
                            : card.price,
                        [PHYSICAL_ATTRIBUTES.NAME_ON_CARD.name]: isLegacy
                            ? card.custom_card_details.recipient_name
                            : null,
                        [PHYSICAL_ATTRIBUTES.CARD_MESSAGE.name]: isLegacy
                            ? card.custom_card_details.emboss_message
                            : null,
                        [PHYSICAL_ATTRIBUTES.CARRIER_TO.name]: isLegacy
                            ? card.custom_card_details.shipping_name
                            : null,
                        [PHYSICAL_ATTRIBUTES.CARRIER_FROM.name]: isLegacy
                            ? card.custom_card_details.carrier_from
                            : null,
                        [PHYSICAL_ATTRIBUTES.CARRIER_MESSAGE.name]: isLegacy
                            ? card.custom_card_details.carrier_message
                            : null,
                    }
                    if (individualDeliveryStyle) {
                        gridRowData[PHYSICAL_ATTRIBUTES.SHIP_TO.name] = isLegacy
                            ? {
                                  name: card.custom_card_details.shipping_name,
                                  addressLine1:
                                      card.custom_card_details.address_line1,
                                  addressLine2:
                                      card.custom_card_details.address_line2,
                                  city: card.custom_card_details.city,
                                  state: card.custom_card_details.state,
                                  zip: card.custom_card_details.zip_code,
                              }
                            : {}
                    }
                    return gridRowData
                } else {
                    return {
                        rowId: uuidv4(),
                        [DIGITAL_ATTRIBUTES.AMOUNT.name]: isLegacy
                            ? card.custom_card_details.load_value
                            : card.price,
                        [DIGITAL_ATTRIBUTES.FULL_NAME.name]: isLegacy
                            ? card.custom_card_details.recipient_name
                            : null,
                        [DIGITAL_ATTRIBUTES.EMAIL_MESSAGE.name]: isLegacy
                            ? card.custom_card_details.recipient_message
                            : null,
                        [DIGITAL_ATTRIBUTES.EMAIL_ADDRESS.name]: isLegacy
                            ? card.custom_card_details.recipient_email
                            : null,
                        [DIGITAL_ATTRIBUTES.SENDER_NAME.name]: card.sender_name,
                    }
                }
            }),
        }
    })

    return customizationData
}
